import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/src/components/footer/footer.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotFound"] */ "/vercel/path0/src/components/notFound/notFound.comp.tsx");
